import { HttpClient } from '@connect-x-app/hybrid-data-access';
import { QuickReply } from '@connect-x-app/shared-domain-models';
import { API_FACTORY } from '@connect-x-app/shared-utils';

export const getQuickReplies = (): Promise<Required<QuickReply>[]> => HttpClient.get(API_FACTORY.v1('admin/quick-replies'));

export const createQuickReply = (quickReply: QuickReply): Promise<QuickReply[]> =>
  HttpClient.post(API_FACTORY.v1('admin/quick-replies'), quickReply);

export const updateQuickReply = (quickReply: QuickReply) =>
  HttpClient.put(API_FACTORY.v1(`admin/quick-replies/${quickReply.id}`), quickReply);

export const deleteQuickReply = (id: string) => HttpClient.delete(API_FACTORY.v1(`admin/quick-replies/${id}`));
